import React, { useEffect, useState } from "react";
import styled from "styled-components";
import IconSearch from '../../assets/images/icon-search-1.svg'
import IconLocation from '../../assets/images/icon-location-1.svg'
import IconArrow from '../../assets/images/icon-prev.svg'

const Container = styled.div`
    width: 100%;
    /* height: 100%; */
`;

const Banner = styled.div`
    width: calc(100% - 48px);
    height: 64px;
    background: linear-gradient(153.06deg, rgba(246, 210, 133, 0.3) -0.31%, rgba(187, 240, 243, 0.3) 99.69%);
    display: flex;
    padding: 0px 24px;
    position: relative;

    .icon-survey-box {
        width: 114px;
        .icon-survey {
            width: 122px;
        }
    }

    .label {
        width: 200px;
        color: #25368D;
        font-size: 24px;
        font-weight: 600;
        line-height: 35.88px;
        text-align: center;
    }

    .icon-search {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: #FBE250;
        cursor: pointer;
        position: absolute;
        transform: translateY(-50%);
        top: 50%;
        right: 16px;
    }

    .search-box {
        width: calc(100% - 25px);

        .input-search {
            width: calc(100% - 88px);
            height: 36px;
            border-radius: 30px;
            border-width: 0px;
            padding: 0px 16px;
            background-color: #F5F5F5;
            color: #25368D;
            margin-left: 8px;
        }
    }

    ::placeholder {
        color: #838BB4;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
        opacity: 1;
    }

    ::-ms-input-placeholder {
        color: #838BB4;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
        opacity: 1;
    }
`;

const Body = styled.div`
    width: calc(100% - 48px);
    height: calc(100% - 112px);
    padding: 24px;
    display: flex;
    flex-direction: column;

    .description {
        color: #2A2A2A;
        font-size: 20px;
        font-weight: 400;
        line-height: 29.9px;
        text-align: left;
        margin-bottom: 16px;
    }
    .title {
        color: #25368D;
        font-size: 24px;
        font-weight: 500;
        line-height: 35.88px;
        text-align: left;
        margin-bottom: 12px;
    }
`;

const Card = styled.div`
    min-height: 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 13px;
    border: 1px solid #F1F1F190;
    box-shadow: 0px 5px 14px 0px #00266F11;
    margin-bottom: 8px;
    padding: 16px;
    cursor: pointer;

    .label-title {
        color: #25368D;
        font-size: 15px;
        font-weight: 400;
        line-height: 22.43px;
        text-align: left;
    }

    .label-sub-title {
        color: #505050;
        font-size: 14px;
        font-weight: 300;
        line-height: 20.93px;
        text-align: left;
        padding-top: 2px;
    }
`;

function EvaluationFormSelect({
    list,
    onClickSelect,
}) {
    const [isSearch, setIsSearch] = useState(false);
    const [search, setSearch] = useState();
    const [listItemDefault, setListItemDefault] = useState([]);
    const [listItem, setListItem] = useState([]);

    useEffect(() => {
        if (Array.isArray(list)) {
            setListItem(list)
            setListItemDefault([...list])
        }
    }, [list])

    function handleSelect(param) {
        onClickSelect && onClickSelect(param);
    }
    function handleSearch() {
        if (isSearch) {
            let list = JSON.parse(JSON.stringify(listItemDefault));
            list = list.filter(x => x.evaluation_form_evaluation_data?.title?.toLocaleLowerCase().includes(search?.toLocaleLowerCase()) ||
                x.location_location_name?.toLocaleLowerCase().includes(search?.toLocaleLowerCase()) ||
                x.location_province?.toLocaleLowerCase().includes(search?.toLocaleLowerCase())
            )
            if (!search) {
                list = [];
            }
            setListItem(list)
        } else {
            setSearch("");
            setListItem([])
            setIsSearch(true);
        }
    }
    function handleCancelSearch() {
        let list = JSON.parse(JSON.stringify(listItemDefault));
        setListItem(list);
        setSearch("")
        setIsSearch(false);
    }
    function handleInputSearch(param) {
        let value = param.target.value;
        setSearch(value)

    }
    function handleKeyPress(event) {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };

    return (
        <Container>
            <Banner>
                {isSearch ?
                    <div className="search-box vertical-center">
                        <img alt="img" src={IconArrow} style={{ width: "24px", height: "24px", cursor: "pointer" }} onClick={handleCancelSearch} />
                        <input
                            className="input-search"
                            placeholder="ค้นหาจากชื่อสถานที่ หรือชื่ออีเว้นท์"
                            value={search}
                            onInput={(e) => { handleInputSearch(e) }}
                            onKeyPress={handleKeyPress} />
                    </div>
                    :
                    <div className="label vertical-center">แบบประเมินใกล้คุณ</div>
                }

                <div className="icon-search content-center" onClick={handleSearch}><img alt="img" src={IconSearch} style={{ width: "24px", height: "24px" }} /></div>
            </Banner>
            <Body>
                <div className="description">{isSearch ? 'การค้นหา' : 'เลือกแบบประเมินที่ต้องการ'}</div>
                {listItem.map((_value, index) => {
                    return (
                        <Card key={index} onClick={() => handleSelect(_value)}>
                            <div className="label-title">{_value?.evaluation_form_evaluation_type === "Place" ? _value?.location_location_name || "" : _value?.evaluation_form_evaluation_data?.title || ""}</div>
                            {_value?.evaluation_form_evaluation_type === "Place" &&
                                <div className="vertical-center" style={{ marginTop: "4px" }}>
                                    <img alt="img" src={IconLocation} style={{ marginRight: "8px" }} />
                                    <div className="label-sub-title"> {_value?.location_province || ""}</div>
                                </div>
                            }
                        </Card>)
                })}
                {listItem.length === 0 &&
                    <div className="content-center" style={{ width: "100%", marginBottom: "8px" }}>
                        No Data.
                    </div>
                }
            </Body>
        </Container>
    )
}

export default EvaluationFormSelect;